module.exports = __webpack_public_path__ + "img/360int-red.20dca16e.svg";